(function () {
  var SvgChartGlobal = MST;
  var SvgChartUtil = MST.SvgChartUtil;
  var SvgChartColorSelect = MST.SvgChartColorSelect;
  var SvgChartTechnicalSetting = MST.SvgChartTechnicalSetting;

  var SvgChartControllerView = function (chart) {
    this.chart = chart;

    this.controllerViewDiv = document.createElement("div");
    this.controllerViewDiv.style.position = "absolute";
    this.controllerViewDiv.style.zIndex = 7;
    this.controllerViewDiv.style.width = "100%";
    chart.chartDiv.appendChild(this.controllerViewDiv);

    this.settingDiv = document.createElement("div");
    this.settingDiv.style.position = "absolute";
    this.settingDiv.style.zIndex = 8;
    this.settingDiv.style.width = "100%";
    chart.chartDiv.appendChild(this.settingDiv);

    var rangeViewPositionDiv = document.createElement("div");
    rangeViewPositionDiv.style.height = SvgChartGlobal.RANGE_VIEW_HEIGHT/16 + "rem";
    chart.chartDiv.appendChild(rangeViewPositionDiv);

    if (this.chart.chartConfig.controller.showBenchmark) {
      this.benchmarkControllerView = new SvgChartBenchmarkControllerView(this);
    }

    if (this.chart.chartConfig.controller.showIndicator) {
      this.indicatorControllerView = new SvgChartIndicatorControllerView(this);
    }

    if (!Raphael.svg && this.chart.chartConfig.controller.showUpdateBrowser) {
      var span = document.createElement("span");
      span.className = "showUpdateBrowser";
      span.innerHTML = this.chart.getLabel("update_browser");
      this.controllerViewDiv.appendChild(span);
    }

    if (this.chart.chartConfig.controller.showType) {
      this.typeControllerView = new SvgChartTypeControllerView(this);
    }

    if (this.chart.chartConfig.controller.showChartRange) {
      this.rangeView = new SvgChartRangeView(this);
    }

    if (this.chart.chartConfig.controller.showReset) {
      var div = document.createElement("div");
      div.className = "div_reset";
      this.controllerViewDiv.appendChild(div);
      if (!Raphael.svg) {
        div.className = "div_reset_ie8";
      }

      let resetButton = document.createElement("button");
      resetButton.className = "icon_reset";
      resetButton.setAttribute("title", this.chart.getLabel("reset"));
      div.appendChild(resetButton);

      (function (chart) {
        resetButton.onclick = function () {
          chart.chartDiv.innerHTML = "";
          chart.loadingDiv = null;
          chart.viewList = null;
          chart.timeFrameUpdated = true;
          chart.benchmarks = [];
          chart.setParams(
            chart.code,
            chart.name,
            chart.exchange,
            chart.chartConfig
          );

          if (typeof showCompareComment === "function") {
            showCompareComment(0);
          }
        };
      })(this.chart);
    }

    var util = new SvgChartUtil();
    util.attachTouchEventOld(this, this.controllerViewDiv);
  };

  SvgChartControllerView.prototype.hiddenOtherItems = function (param) {
    if (
      param != "indicators" &&
      this.chart.chartConfig.controller.showIndicator &&
      this.indicatorControllerView.viewDiv.style.visibility == "visible"
    ) {
      this.indicatorControllerView.hiddenItem();
    }
    if (
      param != "benchmarks" &&
      this.chart.chartConfig.controller.showBenchmark &&
      this.benchmarkControllerView.viewDiv.style.visibility == "visible"
    ) {
      this.benchmarkControllerView.hiddenItem();
    }
  };

  SvgChartControllerView.prototype.onClickEvent = function (
    target,
    param,
    event
  ) {
    this.hiddenOtherItems(param);

    if (param == "indicators") {
      this.indicatorControllerView.toggleShowItem();
    } else if (param == "benchmarks") {
      this.benchmarkControllerView.toggleShowItem();
    } else if (param == "chartType") {
      this.typeControllerView.viewDiv.style.visibility = "visible";
    }
    if (!event) var event = window.event;
    event.cancelBubble = true;
    event.returnValue = false;
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
  };

  SvgChartControllerView.prototype.removeIndicator = function (name) {
    var objs = this.chart.indicatorObjs;
    for (i in objs) {
      if (i == name) {
        objs[i].checked = false;
      }
    }
    var objs = this.chart.benchmarkObjs;
    for (i in objs) {
      if (i == name) {
        objs[i].checked = false;
      }
    }
    this.chart.setBenchmarksIndicators();
  };

  SvgChartControllerView.prototype.init = function () {
    if (this.chart.chartConfig.controller.showIndicator)
      this.indicatorControllerView.initIndicators(this.chart.techGroupList);

    var objs = this.chart.benchmarkObjs;
    for (var i in objs) {
      var tech = this.chart.findBenchmark(i);
      objs[i].checked = tech != null;
      if (tech != null) {
        objs[i].colorPanel.style.backgroundColor = tech.dataColor[0];
      }
    }

    objs = this.chart.chartTypeObjs;
    for (var l in objs) {
      var className = objs[l].className;
      className = className.replace("_selected", "");
      if (this.chart.mainMapping.benchmark == false) {
        objs[l].className =
          l == this.chart.mainTechnical.name
            ? className + "_selected"
            : className;
      }
    }
  };

  var SvgChartControllerItem = function () {};

  SvgChartControllerItem.prototype.initButton = function (
    controllerView,
    value
  ) {
    var button = document.createElement("span");
    button.className = "SvgChartControllerIndicator";
    button.appendChild(
      document.createTextNode(controllerView.chart.getLabel(value))
    );
    this.controllerItemIcon = document.createElement("span");
    this.controllerItemIcon.className = "icon_zk";
    button.appendChild(this.controllerItemIcon);

    controllerView.controllerViewDiv.appendChild(button);

    var util = new SvgChartUtil();
    util.attachClickEvent(controllerView, value, button);

    return button;
  };

  SvgChartControllerItem.prototype.initView = function (
    controllerView,
    offsetLeft,
    width
  ) {
    this.controllerView = controllerView;
    this.chart = controllerView.chart;
    this.viewDiv = document.createElement("div");
    this.viewDiv.style.position = "absolute";
    this.viewDiv.style.visibility = "hidden";
    this.viewDiv.className = "SvgChartIndicatorControllerView";
    this.viewDiv.style.zIndex = 8;
    this.viewDiv.style.width = width + "px";
    this.chart.chartDiv.insertBefore(
      this.viewDiv,
      this.chart.backgroundView.backgroundDiv
    );

    this.viewDiv.style.left = offsetLeft + 2 + "px";

    this.settingDiv = document.createElement("div");
    this.settingDiv.style.position = "absolute";
    this.settingDiv.style.zIndex = 9;
    this.settingDiv.style.left = offsetLeft + "px";
    controllerView.settingDiv.appendChild(this.settingDiv);

    var t = this;
    this.viewDiv.onscroll = function () {
      t.colorSelect.colorSelectOutDiv.style.display = "none";
    };

    var util = new SvgChartUtil();
    util.attachTouchEventOld(this, this.viewDiv);
    util.attachClickEvent(this, "", this.viewDiv);
  };

  SvgChartControllerItem.prototype.onClickEvent = function (
    target,
    pharse,
    event
  ) {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    } else {
      window.event.cancelBubble = true;
    }
  };

  SvgChartControllerItem.prototype.onTouchEvent = function (
    target,
    pharse,
    cursorCoords
  ) {
    return true;
  };

  SvgChartControllerItem.prototype.addCheckbox = function (
    ul,
    benchmark,
    deletable,
    newUl
  ) {
    var li = document.createElement("li");
    li.style.height = "auto";
    deletable > 5 ? newUl.appendChild(li) : ul.appendChild(li);
    var id = benchmark.id;
    var name = benchmark.name;

    var colorPanel = document.createElement("span");
    colorPanel.className = "SvgChartColorRect";
    colorPanel.style.top = "6px";
    colorPanel.style.left = "24px";
    colorPanel.style.marginRight = "-20px";
    colorPanel.style.backgroundColor = "#eee";
    colorPanel.style.cursor = "default";
    li.appendChild(colorPanel);

    var select = document.createElement("i");
    colorPanel.appendChild(select);

    var checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.value = id;
    checkbox.id = "chart_checkbox_" + id;
    checkbox.style.display = "none";
    li.appendChild(checkbox);

    var checkboxLabel = document.createElement("label");
    checkboxLabel.className = "cklabel-before";
    checkboxLabel.innerHTML = name;
    li.appendChild(checkboxLabel);

    checkbox.checkboxLabel = checkboxLabel;

    var maxWidth = 420;
    // if (this.chart.chartWidth < maxWidth) {
    //   checkboxLabel.style.maxWidth = this.chart.chartWidth * 0.8 + "px";
    // }

    if (benchmark.type == "default") {
      checkbox.checked = true;
      checkboxLabel.className = "cklabel-after";
    }

    var t = this;
    (function (checkboxLabel, checkbox, t) {
      checkboxLabel.onclick = function () {
        if (checkbox.disabled) return;
        if (benchmark.type == "default") return;

        var benchmarkCheckedCount = 1;
        for (var key in t.chart.benchmarkObjs) {
          if (
            t.chart.benchmarkObjs[key].checked == true &&
            benchmark.type != "default"
          ) {
            benchmarkCheckedCount++;
          }
        }

        if (
          benchmarkCheckedCount >= SvgChartGlobal.BENCHMARK_LIMIT &&
          checkbox.checked == false
        ) {
          t.showBenchmarkError(
            "比較は最大" + SvgChartGlobal.BENCHMARK_LIMIT + "個までです"
          );
          return;
        }

        var maxWidth = 420;
        checkbox.checked = !checkbox.checked;

        if (checkbox.checked == false) {
          var tech = t.chart.findBenchmark(checkbox.value);
          t.chart.colorSelectList[tech.dataColor[0]] = null;
        }

        t.chart.setBenchmarksIndicators();
        if (checkbox.checked) {
          checkboxLabel.className = "cklabel-after";
        } else {
          checkboxLabel.className = "cklabel-before";
        }

        // if (t.chart.chartWidth < maxWidth) {
        //   checkboxLabel.style.maxWidth = t.chart.chartWidth * 0.8 + "px";
        // }

        var benchmarkCheckedCount = 0;
        for (var key in t.chart.benchmarkObjs) {
          if (
            t.chart.benchmarkObjs[key].checked == true &&
            benchmark.type != "default"
          ) {
            benchmarkCheckedCount++;
          }
        }
        if (typeof showCompareComment === "function") {
          showCompareComment(benchmarkCheckedCount);
        }
      };
    })(checkboxLabel, checkbox, this);

    colorPanel.onclick = function () {
      if (checkbox.disabled) return;
      if (checkbox.checked) {
        var tech = t.chart.findBenchmark(checkbox.value);
        checkbox.technical = tech;
        t.colorSelect.show(checkbox.technical, 0, colorPanel);
      }
      if (t.chart.techGroupList[0][0].code == checkbox.value) {
        checkbox.technical = t.chart.techGroupList[0][0];
        t.colorSelect.show(checkbox.technical, 0, colorPanel);
      }
    };

    checkbox.colorPanel = colorPanel;

    if (
      benchmark.type != "index" &&
      benchmark.type != "default" &&
      benchmark.type != "futures" &&
      benchmark.type != "fund"
    ) {
      var removeRect = document.createElement("span");
      var remove = document.createElement("span");
      removeRect.className = "SvgChartColorRect";
      removeRect.style.float = "right";
      remove.className = "SvgChartLabelRemove";
      removeRect.appendChild(remove);
      li.appendChild(removeRect);

      removeRect.onclick = function () {
        var tech = t.chart.findBenchmark(benchmark.id);
        if (tech != null) {
          t.chart.colorSelectList[tech.dataColor[0]] = null;
        }

        delete t.chart.benchmarkObjs[benchmark.id];
        t.chart.setBenchmarksIndicators();
        ul.removeChild(li);
      };
    }

    return checkbox;
  };

  SvgChartControllerItem.prototype.showItem = function () {
    if (this.viewDiv) {
      this.viewDiv.style.visibility = "visible";
      if (this.controllerItemIcon) {
        this.controllerItemIcon.className = "icon_sl";
      }
      this.extended = true;
    }
  };

  SvgChartControllerItem.prototype.hiddenItem = function () {
    if (this.viewDiv) {
      this.viewDiv.style.visibility = "hidden";
      if (this.controllerItemIcon) {
        this.controllerItemIcon.className = "icon_zk";
        if (this.colorSelect)
          this.colorSelect.colorSelectOutDiv.style.display = "none";
      }
      this.extended = false;

      if (this.benchmarkSelectDiv) {
        this.benchmarkSelectDiv.style.display = "none";
        this.benchmarkInput.value = "";
      }
    }
  };

  SvgChartControllerItem.prototype.toggleShowItem = function () {
    if (this.extended) {
      this.hiddenItem();
    } else {
      this.showItem();
    }
  };

  var SvgChartIndicatorControllerView = function (controllerView) {
    var indicatorButton = this.initButton(controllerView, "indicators");
    this.initView(controllerView, 156, 180);

    this.menuItem = indicatorButton;

    this.displayStatus = {};
    var indicators = this.chart.chartConfig.controller.indicators;
    for (var i = 0; i < indicators.length; i++) {
      this.displayStatus[indicators[i]] = { techCount: 0, display: "none" };
    }
  };

  SvgChartIndicatorControllerView.prototype = new SvgChartControllerItem();

  SvgChartIndicatorControllerView.prototype.initIndicators = function (
    techGroupList
  ) {
    this.techCount = {};
    var objs = this.viewDiv.childNodes;
    for (var i = objs.length - 1; i >= 0; i--) {
      this.viewDiv.removeChild(objs[i]);
    }

    this.labelDiv = this.settingDiv;
    this.colorSelect = new SvgChartColorSelect(this);
    this.colorSelect.viewDiv = this.viewDiv;

    var indicators = this.chart.chartConfig.controller.indicators;

    this.chart.indicatorObjs = {};
    for (var i = 0; i < indicators.length; i++) {
      var indicatorsNameDiv = document.createElement("div");
      indicatorsNameDiv.className = "ofh";
      this.viewDiv.appendChild(indicatorsNameDiv);

      var button = document.createElement("div");
      // button.type = "image";
      button.style.float = "left";

      indicatorsNameDiv.appendChild(button);

      var span = document.createElement("span");
      span.innerHTML = this.chart.getLabel(indicators[i]);
      button.appendChild(span);

      var icon_span = document.createElement("span");
      indicatorsNameDiv.appendChild(icon_span);

      var div = document.createElement("div");
      div.className = "SvgChartIndicatorCategory";
      this.viewDiv.appendChild(div);

      this.techCount[indicators[i]] = 0;

      var buttonDisabled = false;
      var technicals = [];
      for (var j = 0; j < techGroupList.length; j++) {
        for (var k = 0; k < techGroupList[j].length; k++) {
          var tech = techGroupList[j][k];
          if (tech.name == indicators[i]) {
            technicals.push(tech);

            var techSetting = new SvgChartTechnicalSetting(tech);
            tech.techSetting = techSetting;
            div.appendChild(techSetting.techSettingDiv);
            techSetting.techSettingDiv.className = "detail";

            if (!tech.plural) {
              div.className = "SvgChartIndicatorCategory multiParams";
            }

            this.techCount[tech.name]++;
            buttonDisabled = true;
          }
        }
      }

      var addbutton = null;

      if (this.techCount[indicators[i]] > 0) {
        if (technicals[0].plural) {
          var addbutton = document.createElement("span");
          addbutton.innerHTML = this.chart.getLabel("add");
          addbutton.style.background = "#f0f0f0";
          addbutton.style.padding = "3px";
          addbutton.style.cursor = "pointer";
          div.appendChild(addbutton);

          if (
            this.techCount[indicators[i]] &&
            this.techCount[indicators[i]] >= technicals[0].maxCount
          ) {
            addbutton.className = "button_disable";
          }
        }

        div.style.display = "none";

        (function (icon_span, div, displayStatus) {
          icon_span.onclick = function () {
            if (div.style.display == "") {
              div.style.display = "none";
              icon_span.className = "icon_zk";
            } else {
              div.style.display = "";
              icon_span.className = "icon_sl";
            }
            displayStatus.display = div.style.display;
          };
        })(icon_span, div, this.displayStatus[indicators[i]]);
      } else {
        var addbutton = button;
      }
      this.displayStatus[indicators[i]].techCount =
        this.techCount[indicators[i]];

      if (buttonDisabled) {
        button.className = "SvgChartIndicatorButtonPlusDisable";
      } else {
        button.className = "SvgChartIndicatorButtonPlus";
      }

      if (addbutton != null && addbutton.className != "button_disable") {
        (function (chart, button, name, indicatorsDiv) {
          button.onclick = function () {
            if (chart.initIndicator(name)) {
              chart.prepareView(true);
              chart.prepareActionView();
              chart.loadData();
            }
            chart.drawAll();
          };
        })(this.chart, addbutton, indicators[i], this);
      }
      if (buttonDisabled) {
        (function (chart, button, technicals) {
          button.onclick = function () {
            for (var j = 0; j < technicals.length; j++) {
              chart.removeTechnical(technicals[j].techId);
            }
          };
        })(this.chart, button, technicals);
      }
    }
  };

  SvgChartIndicatorControllerView.prototype.toggleStatus = function (v) {
    var className = this.menuItem.className;
    var reg = new RegExp("(\\s|^)button_disable(\\s|$)");
    if (!v) {
      if (!className.match(reg)) {
        className += " button_disable";
      }
    } else {
      if (className.match(reg)) {
        className = className.replace(reg, "");
      }
    }
    this.menuItem.className = className;
  };

  var SvgChartBenchmarkControllerView = function (controllerView) {
    var benchmarkButton = this.initButton(controllerView, "benchmarks");

    this.initView(controllerView, benchmarkButton.offsetLeft, 150);

    var benchmarks = [];
    var benchmarkCount = 0;
    for (var p in this.chart.indicatorViewBenchmarks) {
      benchmarkCount++;
    }

    for (var i = 0; i < benchmarkCount; i++) {
      for (var p in this.chart.indicatorViewBenchmarks) {
        if (this.chart.indicatorViewBenchmarks[p]["index"] == i) {
          benchmarks.push(this.chart.indicatorViewBenchmarks[p]);
        }
      }
    }

    this.initBenchmarks(benchmarks);
    this.menuItem = benchmarkButton;
  };

  SvgChartBenchmarkControllerView.prototype = new SvgChartControllerItem();

  SvgChartBenchmarkControllerView.prototype.initBenchmarks = function (
    benchmarks
  ) {
    this.labelDiv = this.settingDiv;
    this.colorSelect = new SvgChartColorSelect(this);
    this.colorSelect.viewDiv = this.viewDiv;

    var benchmarkDiv = document.createElement("div");
    benchmarkDiv.className = "mb10";
    this.viewDiv.appendChild(benchmarkDiv);

    var input = document.createElement("input");
    this.benchmarkInput = input;
    input.placeholder = "比較するファンド名・コード";
    input.type = "text";
    input.style.width = "90px";
    input.style.height = "20px";
    input.maxLength = "10";
    benchmarkDiv.appendChild(input);

    var button = document.createElement("span");
    //	 button.type = "button";
    button.innerHTML = this.chart.getLabel("add");
    button.style.background = "#f0f0f0";
    button.style.padding = "3px";
    button.style.cursor = "pointer";

    var t = this;

    input.onkeyup = function () {
      t.search_ticker();
      setTimeout(() => { t.search_ticker(); }, 1000);
    };

    var helpImg = document.createElement("span");
    helpImg.className = "benchmark-help";
    helpImg.title = this.chart.getLabel("benchmark_help");
    benchmarkDiv.appendChild(helpImg);

    var errorDiv = document.createElement("div");
    this.benchmarkErrorDiv = errorDiv;
    errorDiv.className = "SvgChartIndicatorBenchmarkError";
    errorDiv.style.visibility = "hidden";
    this.viewDiv.appendChild(errorDiv);

    var selectDiv = document.createElement("div");
    this.benchmarkSelectDiv = selectDiv;
    selectDiv.className = "SvgChartIndicatorBenchmarkSelect";
    //	selectDiv.style.visibility = "hidden";
    this.viewDiv.parentNode.appendChild(selectDiv);
    this.benchmarkSelectDiv.style.display = "none";

    var ul = document.createElement("ul");
    ul.style.paddingLeft = "5px";
    this.bechmarkUl = ul;
    this.viewDiv.appendChild(ul);

    var newUl = document.createElement("ul");
    newUl.style.paddingLeft = "5px";
    newUl.className = "SvgChartSelectNewDiv";
    this.viewDiv.appendChild(newUl);

    var newAddUl = document.createElement("ul");
    newAddUl.style.paddingLeft = "5px";
    newAddUl.className = "SvgChartAddItem";
    this.newItemUl = newAddUl;
    // this.viewDiv.appendChild(newAddUl);

    var isUlTop = $("body").hasClass("sp_body");
    var isCompare = $(".fund_compare_dailog").length > 0;
    if (isUlTop && !isCompare) {
      $(ul).after(newAddUl);
    } else {
      $(newUl).after(newAddUl);
    }

    this.chart.benchmarkObjs = {};
    var addFundTitleStatus = 0;
    for (var i = 0; i < benchmarks.length; i++) {
      if (benchmarks[i].type == "fund") {
        addFundTitleStatus++;
      }

      if (
        addFundTitleStatus == 1 &&
        this.chart.addBenchmarkFundTitleFlag == true
      ) {
        var fundTitle = document.createElement("li");
        fundTitle.className = "SvgChartSelectNewTitle";
        fundTitle.innerHTML = "同一分類ファンド";
        newUl.appendChild(fundTitle);
      }

      var checkbox = this.addCheckbox(ul, benchmarks[i], i, newUl);
      this.chart.benchmarkObjs[benchmarks[i].id] = checkbox;
      this.chart.benchmarkObjs[benchmarks[i].id].colorPanel.style.cursor =
        "pointer";

      if (benchmarks[i].type == "default") {
        checkbox.checked = true;
        checkbox.checkboxLabel.style.cursor = "not-allowed";
        checkbox.checkboxLabel.style.opacity = "0.5";
        checkbox.checkboxLabel.className = "cklabel-after";
        this.chart.benchmarkObjs[
          benchmarks[i].id
        ].colorPanel.style.backgroundColor = SvgChartGlobal.COLOR_PANEL[0];
        this.chart.benchmarkObjs[benchmarks[i].id].colorPanel.style.cursor =
          "pointer";
      }
    }
  };

  SvgChartBenchmarkControllerView.prototype.showBenchmarkError = function (
    error
  ) {
    this.benchmarkErrorDiv.innerHTML = error;
    this.benchmarkErrorDiv.style.visibility = "visible";
    (function (t) {
      setTimeout(function () {
        t.benchmarkErrorDiv.style.visibility = "hidden";
      }, 3000);
    })(this);
  };

  SvgChartBenchmarkControllerView.prototype.search_ticker = function () {
    var benchmark_input = this.benchmarkInput.value;
    if (benchmark_input == "") {
      this.benchmarkSelectDiv.style.display = "none";
      return;
    }

    var t = this;
    SvgChartGlobal.testRic(benchmark_input, null, function (data) {
      t.search_ticker_continue(benchmark_input, data);
    });
  };

  SvgChartBenchmarkControllerView.prototype.search_ticker_continue = function (
    benchmark_input,
    data
  ) {
    var objs = this.benchmarkSelectDiv.childNodes;
    for (var i = objs.length - 1; i >= 0; i--) {
      this.benchmarkSelectDiv.removeChild(objs[i]);
    }
    this.benchmarkSelectDiv.style.display = "none";
    if (data["items"].length == 0) {
      this.showBenchmarkError(
        "「" + benchmark_input + "」に該当するファンドが見つかりませんでした。"
      );
      return;
    } else {
      var ii = 0;
      for (var i = 0; i < data["items"].length; i++) {
        if (ii >= 10) break;
        ii++;
        var li = document.createElement("div");
        li.className = "clearfix";
        this.benchmarkSelectDiv.appendChild(li);
        var span = document.createElement("span");
        span.innerHTML = data["items"][i]["name"];
        li.appendChild(span);

        (function (t, li, ric, name) {
          li.onclick = function () {
            t.add_ric(ric, name);
            t.benchmarkSelectDiv.style.display = "none";
          };
        })(this, li, data["items"][i]["ric"], data["items"][i]["name"]);
      }
      if (ii > 0) {
        this.benchmarkSelectDiv.style.display = "";
      }
    }
  };

  SvgChartBenchmarkControllerView.prototype.testListingEvents = function () {
    var benchmark_input = this.benchmarkInput.value;
    var t = this;
    SvgChartGlobal.listingEvents(
      benchmark_input,
      null,
      function (data) {
        if (data["items"].length > 0) {
          t.showBenchmarkError(
            "ファンド「" + benchmark_input + "」は、上場廃止になりました。"
          );
        } else {
          t.showBenchmarkError(
            "「" +
              benchmark_input +
              "」に該当するファンドが見つかりませんでした。"
          );
        }
      },
      function () {
        t.showBenchmarkError(
          "「" +
            benchmark_input +
            "」に該当するファンドが見つかりませんでした。"
        );
      }
    );
  };

  SvgChartBenchmarkControllerView.prototype.add_ric = function (
    benchmark,
    name
  ) {
    if (benchmark == this.chart.code) {
      this.benchmarkInput.value = "";
      this.showBenchmarkError("該当ファンドが既に表示されています");
      return;
    }

    // check benchmark number whether more than limit number
    var benchmarkCheckedCount = 1;
    for (var key in this.chart.benchmarkObjs) {
      if (
        this.chart.benchmarkObjs[key].checked == true &&
        this.chart.mainTechnical.code != key
      ) {
        benchmarkCheckedCount++;
      }
    }

    // if(this.chart.benchmarkObjs && Object.keys(this.chart.benchmarkObjs).length >= SvgChartGlobal.BENCHMARK_LIMIT){
    if (benchmarkCheckedCount >= SvgChartGlobal.BENCHMARK_LIMIT) {
      this.showBenchmarkError(
        "比較するファンドは最大" +
          SvgChartGlobal.BENCHMARK_LIMIT +
          "ファンドを追加することが出来ます"
      );
      return;
    }

    var checkbox = this.chart.benchmarkObjs[benchmark];
    if (checkbox != null) {
      if (!checkbox.checked) {
        // checkbox.checked = true;
        // checkbox.onclick();
        checkbox.checkboxLabel.onclick();
        this.benchmarkInput.value = "";
      } else {
        this.benchmarkInput.value = "";
        this.showBenchmarkError("該当ファンドが既に比較機能に追加されています");
      }
      return;
    }

    SvgChartGlobal.lang["select"][benchmark] = name;
    var checkbox = this.addCheckbox(
      this.newItemUl,
      { id: benchmark, name: name },
      true
    );
    this.chart.benchmarkObjs[benchmark] = checkbox;
    this.chart.indicatorLabels[benchmark] = benchmark;
    //	checkbox.checked = true;
    //	checkbox.onclick();
    checkbox.checkboxLabel.onclick();
    this.benchmarkInput.value = "";
  };

  SvgChartBenchmarkControllerView.prototype.addBenchmark = function () {
    var benchmark_input = this.benchmarkInput.value;
    if (benchmark_input == "") {
      this.showBenchmarkError("ファンドをご記入ください");
      return;
    }

    var t = this;
    SvgChartGlobal.testRic(
      benchmark_input,
      null,
      function (data) {
        t.addBenchmark_continue(benchmark_input, data);
      },
      function () {
        t.showBenchmarkError(
          "「" + benchmark_input + "」に該当するファンド見つかりませんでした。"
        );
      }
    );
  };

  SvgChartBenchmarkControllerView.prototype.addBenchmark_continue = function (
    benchmark_input,
    data
  ) {
    var idx = -1;
    for (var i = 0; i < data["items"].length; i++) {
      if (data["items"][i]["currency_code"] == "JPY") {
        idx = i;
        break;
      }
    }

    if (idx < 0) {
      this.showBenchmarkError(
        "「" + benchmark_input + "」に該当するファンドが見つかりませんでした。"
      );
      return;
    }

    var name = data["items"][idx]["name"];
    var benchmark = data["items"][idx]["primary_ric"];
    if (benchmark == null) {
      benchmark = data["items"][idx]["ric"];
    }

    if (benchmark == code) {
      this.benchmarkInput.value = "";
      this.showBenchmarkError("該当ファンドが既に表示されています");
      return;
    }

    var benchmarkCheckedCount = 1;
    for (var key in this.chart.benchmarkObjs) {
      if (
        this.chart.benchmarkObjs[key].checked == true &&
        this.chart.mainTechnical.code != key
      ) {
        benchmarkCheckedCount++;
      }
    }

    // check benchmark number whether more than limit number
    // if(this.chart.benchmarkObjs && Object.keys(this.chart.benchmarkObjs).length >= SvgChartGlobal.BENCHMARK_LIMIT){
    if (benchmarkCheckedCount >= SvgChartGlobal.BENCHMARK_LIMIT) {
      this.showBenchmarkError(
        "比較するファンドは最大" +
          SvgChartGlobal.BENCHMARK_LIMIT +
          "ファンドを追加することが出来ます"
      );
      return;
    }

    var checkbox = this.chart.benchmarkObjs[benchmark];
    if (checkbox != null) {
      if (!checkbox.checked) {
        checkbox.checked = true;
        //			this.chart.setBenchmarksIndicators();
        checkbox.onclick();
        this.benchmarkInput.value = "";
      } else {
        this.benchmarkInput.value = "";
        this.showBenchmarkError("該当ファンドが既に比較機能に追加されています");
      }
      return;
    }

    SvgChartGlobal.lang["select"][benchmark] = name;
    var checkbox = this.addCheckbox(
      this.bechmarkUl,
      { id: benchmark, name: name },
      true
    );
    this.chart.benchmarkObjs[benchmark] = checkbox;
    this.chart.indicatorLabels[benchmark] = benchmark;
    checkbox.checked = true;
    checkbox.onclick();
    this.benchmarkInput.value = "";
    //	this.chart.setBenchmarksIndicators();
  };

  //var SvgChartTypeControllerView = function (controllerView) {
  //
  //	var typeButton = this.initButton(controllerView, "chartType");
  //
  //	this.initView(controllerView, typeButton.offsetLeft);
  //
  //	var chartType = ['mountain', 'line', 'candle'];
  ////	for (var p in this.chart.indicatorViewIndicators) {
  ////		indicators.push(p);
  ////		this.chart.indicatorLabels[p] = this.chart.indicatorViewIndicators[p];
  ////	}
  //	this.initChartType(chartType);
  //};
  //
  //SvgChartTypeControllerView.prototype = new SvgChartControllerItem();
  //
  //SvgChartTypeControllerView.prototype.initChartType = function(chartType) {
  //
  //	var ul = document.createElement("ul");
  //	this.viewDiv.appendChild(ul);
  //
  //	this.chart.chartTypeObjs = {};
  //	var lis = [];
  //	for (var i = 0; i < chartType.length; i++) {
  //
  //		var li = document.createElement("li");
  //		ul.appendChild(li);
  //		var span = document.createElement("span");
  //		span.innerHTML = this.chart.getLabel(chartType[i]);
  //		li.appendChild(span);
  //
  //		(function(t, v) {
  //			li.onclick = function() {
  //				t.chart.changeMainTechnical(v);
  //				for (l in t.chart.chartTypeObjs) {
  //					t.chart.chartTypeObjs[l].className = (l == v ? "select" : "");
  //				}
  //			};
  //		})(this, chartType[i]);
  //
  //		this.chart.chartTypeObjs[chartType[i]] = li;
  //	};
  //};

  SvgChartBenchmarkControllerView.prototype.removeBenchmark = function (code) {
    // if(this.bechmarkUl){
    // 	var child = this.bechmarkUl.childNodes;
    // 	for(var i = 0; i < child.length; i++){
    // 		var liList = child[i].childNodes;
    // 		if(liList[0] && liList[0].value == code){
    // 			this.bechmarkUl.removeChild(child[i]);
    // 			break;
    // 		}
    // 	}
    // }

    // if(this.chart.benchmarkObjs[code]){
    // 	delete this.chart.benchmarkObjs[code];
    // }
    var objs = this.chart.benchmarkObjs;
    for (i in objs) {
      if (i == code) {
        objs[i].checked = false;

        var label = objs[i].nextSibling;
        if (label) {
          label.className = "cklabel-before";
        }
      }
    }
    //	while(this.chart.viewList[0].settingDiv.lastChild) {
    //		this.chart.viewList[0].settingDiv.removeChild(this.chart.viewList[0].settingDiv.lastChild);
    //	}

    this.chart.setBenchmarksIndicators();

    var benchmarkCheckedCount = 0;
    for (var key in this.chart.benchmarkObjs) {
      if (this.chart.benchmarkObjs[key].checked == true) {
        benchmarkCheckedCount++;
      }
    }
    if (typeof showCompareComment === "function") {
      showCompareComment(benchmarkCheckedCount);
    }
  };

  var SvgChartTypeControllerView = function (controllerView) {
    this.chart = controllerView.chart;

    // var chartType = ['line', 'mountain', 'candle'];
    var chartType = ["line", "mountain"];

    //	this.initChartType(chartType);
    this.chart.chartTypeObjs = {};
    for (var i = 0; i < chartType.length; i++) {
      var div = document.createElement("div");
      div.className = "charts_type";
      controllerView.controllerViewDiv.appendChild(div);

      var a = document.createElement("a");
      a.setAttribute("href", "javascript:void(0)");
      a.className = "icon_" + chartType[i];
      a.setAttribute("title", this.chart.getLabel(chartType[i]));
      div.appendChild(a);

      (function (t, v) {
        a.onclick = function () {
          if (t.chart.benchmarks && t.chart.benchmarks.length > 0) return;
          // t.chart.onclick();
          // t.chart.changeMainTechnical(v);
          // for (l in t.chart.chartTypeObjs) {
          // 	var obj = t.chart.chartTypeObjs[l];
          // 	var className = "icon_" + l;
          // 	obj.className = (l == v ? className + "_selected" : className);
          // }
          t.changeType(t.chart, v);
        };
      })(this, chartType[i]);
      this.chart.chartTypeObjs[chartType[i]] = a;
    }

    // var span = document.createElement("span");
    // span.className = "chart_line";
    // controllerView.controllerViewDiv.appendChild(span);
  };

  SvgChartTypeControllerView.prototype.changeType = function (chart, type) {
    chart.onclick();
    chart.changeMainTechnical(type);
    for (l in chart.chartTypeObjs) {
      var obj = chart.chartTypeObjs[l];
      var className = "icon_" + l;
      obj.className = l == type ? className + "_selected" : className;
    }
  };

  SvgChartTypeControllerView.prototype.toggleStatus = function (v) {
    for (l in this.chart.chartTypeObjs) {
      var obj = this.chart.chartTypeObjs[l];
      var className = "icon_" + l;
      if (obj.className.indexOf("selected") >= 0) {
        this.preSelected = l;
      }
      if (!v) {
        obj.className = className + " button_disable";
      } else {
        obj.className =
          l == this.preSelected ? className + "_selected" : className;
      }
    }
  };

  var SvgChartRangeView = function (controllerView) {
    var util = new SvgChartUtil();

    this.controllerView = controllerView;
    this.chart = controllerView.chart;

    this.zoomDiv = document.createElement("div");
    this.zoomDiv.className = "SvgChartRange";
    if (!Raphael.svg) {
      this.zoomDiv.className = "SvgChartRange_ie8";
    }
    controllerView.controllerViewDiv.appendChild(this.zoomDiv);

    //	this.intervalDiv = document.createElement("div");
    //	this.intervalDiv.className = "SvgChartRange fl";
    //	this.rangeViewDiv.appendChild(this.intervalDiv);

    var rangeLinkDiv = document.createElement("div");
    rangeLinkDiv.className = "list";
    this.zoomDiv.appendChild(rangeLinkDiv);

    var ranges = this.chart.chartConfig.controller.ranges;
    this.rangeLinks = [];
    for (var i = 0; i < ranges.length; i++) {
      var rangeButton = document.createElement("button");
      this.rangeLinks.push(rangeButton);
      if (ranges[i] == this.chart.timeFrame) {
        rangeButton.className = "SvgChartRangeLinkSelect";
      } else {
        rangeButton.className = "SvgChartRangeLink";
      }
      rangeButton.appendChild(
        document.createTextNode(this.chart.getLabel(ranges[i]))
      );
      rangeLinkDiv.appendChild(rangeButton);
      rangeButton.rangeKey = ranges[i];

      //		if (this.chart.rangeLinks[ranges[i]] != null) {
      //			rangeButton.className = "disabled";
      //		} else {
      util.attachClickEvent(this, ranges[i], rangeButton);
      //		}
    }

    //	var intervalText = document.createElement("span");
    //	intervalText.innerHTML = "Interval:";
    //	intervalText.className = "SvgChartRangeText";
    //	this.intervalDiv.appendChild(intervalText);
    //
    //	var intervalLinkDiv = document.createElement("div");
    //	intervalLinkDiv.className = "list clearfix";
    //	this.intervalDiv.appendChild(intervalLinkDiv);
    //
    //	this.intervalLinks = [];
    //	for (var i = 0; i < SvgChartRangeView.intervals.length; i++) {
    //		var rangeButton = document.createElement("a");
    //		this.intervalLinks.push(rangeButton);
    //		rangeButton.setAttribute("href", "javascript:void(0)");
    //		if (SvgChartRangeView.intervals[i] == chart.period) {
    //			rangeButton.className = "SvgChartRangeLinkSelect";
    //		} else {
    //			rangeButton.className = "SvgChartRangeLink";
    //		}
    //		if (i == SvgChartRangeView.intervals.length - 1) {
    //			rangeButton.style.border = "none";
    //		}
    //		rangeButton.appendChild(document.createTextNode(chart.getLabel(SvgChartRangeView.intervals[i])));
    //		intervalLinkDiv.appendChild(rangeButton);
    //		util.attachClickEvent(this, SvgChartRangeView.intervalRanges[i], rangeButton);
    //	}
    //
    //	// this.dataDiv = document.createElement("div");
    //	// this.dataDiv.style.visibility = "hidden";
    //	// this.dataDiv.style.position = "absolute";
    //	// this.rangeViewDiv.appendChild(this.dataDiv);
    //
    //	var rangeDiv = document.createElement("div");
    //	rangeDiv.className = "SvgChartRange fr";
    //	rangeDiv.style.marginTop = "5px";
    //	this.rangeViewDiv.appendChild(rangeDiv);
    //
    //	this.rangeStart = document.createElement("input");
    //	this.rangeEnd = document.createElement("input");
    //	this.rangeStart.type = "text";
    //	this.rangeEnd.type = "text";
    //	this.rangeStart.className = "SvgChartRangeButton";
    //	this.rangeEnd.className = "SvgChartRangeButton";
    //	this.rangeStart.style.width = "80px";
    //	this.rangeEnd.style.width = "80px";
    //	this.rangeStart.style.height = "14px";
    //	this.rangeEnd.style.height = "14px";
    //	this.rangeStart.style.marginLeft = "1px";
    //	this.rangeEnd.style.marginRight = "20px";
    //
    //	// var t = this;
    //	// this.rangeStart.onmouseout = function() {t.blur();};
    //	// this.rangeEnd.onmouseout = function() {t.blur();};
    //
    //	util.attachKeydownEvent(this, this.rangeStart);
    //	util.attachKeydownEvent(this, this.rangeEnd);
    //
    //	// var rangeSubmit = document.createElement("input");
    //	// rangeSubmit.type = "button";
    //	// rangeSubmit.value = "custom zoom";
    //
    //	rangeDiv.appendChild(this.rangeStart);
    //	rangeDiv.appendChild(this.rangeEnd);
    //	util.attachClickEvent(this, "input", this.rangeStart);
    //	util.attachClickEvent(this, "input", this.rangeEnd);

    // this.rangeUp = document.createElement("span");
    // this.rangeUp.className = "SvgChartViewData";
    // rangeDiv.appendChild(this.rangeUp);

    // rangeDiv.appendChild(rangeSubmit);
    // util.attachClickEvent(this, null, rangeSubmit);

    // var rangeText = document.createElement("span");
    // rangeText.innerHTML = this.chart.getLabel("timeframe");
    // rangeText.className = "SvgChartRangeText";
    // rangeDiv.appendChild(rangeText);
    //
    // this.rangeSelect = document.createElement("select");
    // this.rangeSelect.className = "SvgChartRangeSelect";
    // for (var i = 0; i < ranges.length; i++) {
    // this.rangeSelect.options.add(new Option(this.chart.getLabel(ranges[i]), ranges[i]));
    // }
    // rangeDiv.appendChild(this.rangeSelect);
    //
    // util.attachChangeEvent(this, null, this.rangeSelect);
    //
    // rangeText = document.createElement("span");
    // rangeText.innerHTML = this.chart.getLabel("charttype");
    // rangeText.className = "SvgChartRangeText";
    // rangeDiv.appendChild(rangeText);
    //
    // this.chartTypeSelect = document.createElement("select");
    // this.chartTypeSelect.className = "SvgChartRangeSelect";
    //
    // var charttypes = ["mountain" ,"line" ,"candle"];
    // for (var i = 0; i < charttypes.length; i++) {
    // this.chartTypeSelect.options.add(new Option(this.chart.getLabel(charttypes[i]), charttypes[i]));
    // }
    // rangeDiv.appendChild(this.chartTypeSelect);
    //
    // util.attachChangeEvent(this, "charttype", this.chartTypeSelect);
  };

  //SvgChartRangeView.ranges = ["2D", "1W", "1M", "3M", "6M", "YTD", "1Y", "5Y"];
  SvgChartRangeView.intervalRanges = ["1W", "3M", "1Y"];
  SvgChartRangeView.intervals = ["1h", "daily", "weekly"];
  SvgChartRangeView.prototype.zoomDiv = null;
  SvgChartRangeView.prototype.intervalDiv = null;
  SvgChartRangeView.prototype.chart = null;
  SvgChartRangeView.prototype.rangeSelect = null;
  SvgChartRangeView.prototype.chartTypeSelect = null;
  SvgChartRangeView.prototype.rangeStart = null;
  SvgChartRangeView.prototype.rangeEnd = null;
  // SvgChartRangeView.prototype.param = null;
  // SvgChartRangeView.prototype.finish = true;
  SvgChartRangeView.prototype.volumeCheckBox = null;
  SvgChartRangeView.prototype.inputMode = false;
  SvgChartRangeView.prototype.rangeStartValue = null;
  SvgChartRangeView.prototype.rangeEndValue = null;
  SvgChartRangeView.prototype.unfocusInput = null;
  SvgChartRangeView.prototype.rangeUp = null;
  SvgChartRangeView.prototype.dataDiv = null;

  SvgChartRangeView.prototype.setChartType = function (chartType, benchmark) {
    //	if (chartType != "candle" || benchmark == true) {
    //		this.zoomDiv.style.display = "";
    //		this.intervalDiv.style.display = "none";
    //	} else {
    //		this.zoomDiv.style.display = "none";
    //		this.intervalDiv.style.display = "";
    //	}

    var ranges = this.chart.chartConfig.controller.ranges;
    for (var i = 0; i < ranges.length; i++) {
      if (this.rangeLinks[i].className == "disabled") {
        continue;
      }
      if (ranges[i] == this.chart.timeFrame) {
        this.rangeLinks[i].className = "SvgChartRangeLinkSelect";
      } else {
        this.rangeLinks[i].className = "SvgChartRangeLink";
      }
    }

    //	for (var i = 0; i < SvgChartRangeView.intervals.length; i++) {
    //		if (SvgChartRangeView.intervals[i] == this.chart.period) {
    //			this.intervalLinks[i].className = "SvgChartRangeLinkSelect";
    //		} else {
    //			this.intervalLinks[i].className = "SvgChartRangeLink";
    //		}
    //	}
  };

  SvgChartRangeView.prototype.setDataRange = function (startIndex, length) {
    var data = this.chart.mainTechnical.data;

    if (this.rangeStart != null && this.rangeEnd != null) {
      this.rangeStart.value = this.chart.timeFormat(data[startIndex].date);
      this.rangeEnd.value = this.chart.timeFormat(
        data[startIndex + length - 1].date
      );
      this.inputMode = false;
    }

    // if (this.chart.mainMapping.benchmark == false) {
    // var close1 = data[startIndex].close;
    // var endIndex = Math.min(startIndex + length - 1, this.chart.mainTechnical.lastDataIndex);
    // var close2 = data[endIndex].close;
    // var up = SvgChart.numberFormatFunc(close2 - close1, "price");
    // if (close1 > 0) {
    // var percent = SvgChart.numberFormatFunc((close2 - close1) * 100 / close1, "price");
    // up = up + "(" + percent + "%)";
    // }
    // this.rangeUp.innerHTML = up;
    // } else {
    // var txt = "";
    // for (var t = 0; t < this.chart.viewList[0].technicalList.length; t++) {
    // var technical = this.chart.viewList[0].technicalList[t];
    //
    // if (technical.dataLoadType != SvgChartTechnical.DATA_LOAD_TYPE_URL) continue;
    //
    // var br = "&nbsp;";
    // var label;
    // var dataColor;
    // if (t > 0) {
    // label = technical.code;
    // dataColor = technical.dataColor;
    // } else {
    // label = this.chart.name;
    // dataColor = SvgChartTechnical.technicalMaster["line"].dataColor;
    // }
    //
    // txt = txt + br +"<span style='color:" + dataColor[0] + "'>" + label + "</span>: ";
    //
    // var showv;
    //
    // var endIndex = Math.min(startIndex + length - 1, this.chart.mainTechnical.lastDataIndex);
    // v = technical.data[endIndex][technical.dataLoadName];
    // startv = technical.data[startIndex][technical.dataLoadName];
    //
    // showv = SvgChart.numberFormatFunc(v, "price");
    //
    // var percentv = (v / startv - 1) * 100;
    // showv = Math.round(percentv * 100) / 100 + "%(" + showv + ")";
    // v = percentv;
    //
    // txt = txt + showv;
    // }
    // this.rangeUp.innerHTML = txt;
    // }
  };

  SvgChartRangeView.prototype.onChangeEvent = function (target, param) {
    this.chart.changeMainTechnical(this.chartTypeSelect.value);
  };

  SvgChartRangeView.prototype.onKeydownEvent = function (keyCode) {
    if (keyCode == 13) {
      if (
        this.rangeStartValue != this.rangeStart.value ||
        this.rangeEndValue != this.rangeEnd.value
      ) {
        var data = this.chart.mainTechnical.data;
        ret = SvgChartUtil.getPeriod(
          null,
          data,
          this.rangeStart.value,
          this.rangeEnd.value
        );

        if (data[ret.startIndex].close == null) return;

        var mainMapping = this.chart.mainMapping;
        if (
          mainMapping.dataStartIndex != ret.startIndex ||
          mainMapping.dataLength != ret.dataLength
        ) {
          this.chart.setDataRange(ret.startIndex, ret.dataLength);
        }
        this.rangeStart.value = data[mainMapping.dataStartIndex].date.substring(
          0,
          10
        );
        this.rangeEnd.value = data[
          mainMapping.dataStartIndex + mainMapping.dataLength - 1
        ].date.substring(0, 10);
        this.rangeStartValue = this.rangeStart.value;
        this.rangeEndValue = this.rangeEnd.value;
      }
      this.rangeStart.blur();
      this.rangeEnd.blur();
      this.chart.scrollView.scrollActionStatus = null;
    }
  };

  SvgChartRangeView.prototype.blur = function () {
    this.rangeStart.blur();
    this.rangeEnd.blur();
  };

  SvgChartRangeView.prototype.onClickEvent = function (target, param) {
    if (param == "input") {
      if (this.inputMode == false) {
        var data = this.chart.mainTechnical.data;

        var format = "YYYY/MM/DD";
        var mainMapping = this.chart.mainMapping;
        this.rangeStart.value = data[mainMapping.dataStartIndex].date.substring(
          0,
          10
        );
        this.rangeEnd.value = data[
          mainMapping.dataStartIndex + mainMapping.dataLength - 1
        ].date.substring(0, 10);
        this.rangeStartValue = this.rangeStart.value;
        this.rangeEndValue = this.rangeEnd.value;

        this.inputMode = true;
      }
      return;
    }

    if (param == this.chart.timeFrame) return;

    this.chart.onclick();

    // if (param == "volume") {
    // if (this.volumeCheckBox.checked) {
    // myChart.addTechnical(param);
    // } else {
    // myChart.removeTechnical(param);
    // }
    // return;
    // }

    // var ret = this.getIndex();
    // var data = this.chart.mainTechnical.data;
    // var ret = SvgChartUtil.getPeriod(param, data);
    //
    // var period = ret["period"];
    // if (this.chart.period != period) {
    // this.chart.changePeriod(period);
    // return;
    // }
    //
    // var startIndex = ret["startIndex"];
    // var dataLength = ret["dataLength"];
    // this.chart.setDataRange(startIndex, dataLength);
    this.chart.changeTimeFrame(param);

    if (this.chart.mainMapping.benchmark == false) {
      if (
        (param == "1D" || param == "2D") &&
        this.chart.mainTechnical.name != "mountain"
      ) {
        if (this.chart.controllerView.typeControllerView) {
          this.chart.controllerView.typeControllerView.changeType(
            this.chart,
            "mountain"
          );
        }
      }
    }
    // else{
    // 	this.chart.controllerView.typeControllerView.changeType(this.chart, "line");
    // }

    // this.optionControl();

    this.setChartType(
      this.chart.mainTechnical.name,
      this.chart.mainMapping.benchmark
    );
  };

  SvgChartRangeView.prototype.getIndex = function () {
    var param = this.rangeSelect.value;
    var data = this.chart.mainTechnical.data;
    return SvgChartUtil.getPeriod(param, data);
  };

  MST.SvgChartControllerView = SvgChartControllerView;
})();
